<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.edit-regular"></svg-vue>
          <h1 class="content-title">
            {{ $t('Edit quick reply') }}
          </h1>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4">
          <button class="btn btn-red rounded-none rounded-l-md" type="button" @click="deleteQuickReplyModal = true">
            {{ $t('Delete') }}
          </button>
          <router-link class="btn btn-app rounded-none rounded-r-md" to="/admin/quick-replies">
            {{ $t('Back') }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="content-card-body">
        <loading :status="loading"></loading>
        <form @submit.prevent="saveQuickReply">
          <div class="md:grid md:grid-cols-3 md:gap-6 px-4 py-5 sm:p-6">
            <div class="md:col-span-1">
              <h3 class="form-description-head">
                {{ $t('Quick reply information') }}
              </h3>
              <p class="form-description-text">{{ $t('Update quick reply information and settings') }}.</p>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-2">
              <div class="grid grid-cols-3 gap-6">
                <div class="col-span-3">
                  <label class="form-label" for="name">{{ $t('Name') }}</label>
                  <div class="pt-1">
                    <input :placeholder="$t('Name')" class="form-input" id="name" required v-model="QuickReply.name" />
                  </div>
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="body">{{ $t('Body') }}</label>
                  <input-wysiwyg id="body" v-model="QuickReply.body"></input-wysiwyg>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="inline-flex">
              <router-link class="btn btn-secondary shadow-sm rounded-md mr-4" to="/admin/quick-replies">{{ $t('Cancel') }}</router-link>
              <button class="btn btn-app shadow-sm rounded-md" type="submit">
                {{ $t('Update') }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <quick-reply-delete-model :show="deleteQuickReplyModal" @cancelled="deleteQuickReplyModal = false" @confirmed="deleteQuickReply">
      <template #title>{{ $t('Delete quick reply') }}</template>
      {{ $t('Are you sure you want to delete the quick reply?') }}
      {{ $t('All data will be permanently removed') }}.
    </quick-reply-delete-model>
  </main>
</template>
<script>
import confirmationModel from '@/components/layout/admin/confirmation';

export default {
  name: 'edit',
  components: {
    QuickReplyDeleteModel: confirmationModel,
  },
  metaInfo() {
    return {
      title: this.$i18n.t('Edit quick reply'),
    };
  },
  data() {
    return {
      loading: false,
      deleteQuickReplyModal: false,
      QuickReply: {
        name: null,
        body: '',
      },
    };
  },
  mounted() {
    this.getQuickReply();
  },
  methods: {
    saveQuickReply() {
      this.loading = true;
      axios
        .put(route('quick-replies.update', this.$route.params.id), this.QuickReply)
        .then((response) => {
          this.loading = false;
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getQuickReply() {
      this.loading = true;
      axios
        .get(route('quick-replies.show', this.$route.params.id))
        .then((response) => {
          this.QuickReply = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    deleteQuickReply() {
      axios
        .delete(route('quick-replies.destroy', this.$route.params.id))
        .then((response) => {
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
          this.$router.push('/admin/quick-replies');
        })
        .catch(() => {
          this.deleteQuickReplyModal = false;
        });
    },
  },
};
</script>
